import { Packages } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const StockIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Packages width={size} height={size} color={color} {...rest} />;

StockIcon.displayName = 'StockIcon';

export default StockIcon;
